(() => {
  if (window.inksakeRetirementV1Loaded) return;
  window.inksakeRetirementV1Loaded = true;
  // Limits per ShineOn help center for buyer-personalized watches: 2 lines, 20 chars per line.
  // Each line is its own single-line input, submitted as properties[Engraving Line 1] / [Engraving Line 2].
  const MAX_LINE = 20;
  const GLYPHS = /^[A-Z0-9 .,\-&']*$/;
  const GLYPH_MSG = "Only letters A-Z, numbers 0-9, spaces and . , - & ' are allowed.";
  const SEL = '[data-inksake-retirement-text]';
  const FIELD = '[data-inksake-retirement-field]';

  const normalize = raw => String(raw).replace(/[\r\n]+/g, ' ').replace(/[a-z]/g, c => c.toUpperCase());
  function lineMessage(line, text) {
    if (text.length > MAX_LINE) return 'Line ' + line + ' is too long. Each line can have at most ' + MAX_LINE + ' characters.';
    if (!GLYPHS.test(text)) return GLYPH_MSG;
    return '';
  }
  function check(line, raw) {
    const text = normalize(raw).trim();
    if (line === 1 && !/[A-Z0-9]/.test(text)) return 'Please enter Engraving Line 1.';
    if (line === 2 && text === '') return '';
    return lineMessage(line, text);
  }
  const fieldsOf = group => Array.from(group.querySelectorAll(FIELD));
  const lineOf = field => Number(field.dataset.inksakeLine) || 1;
  function hiddenOf(group) { return group.querySelectorAll('[data-inksake-retirement-hidden]'); }
  function errorOf(group) { return group.querySelector('[data-inksake-retirement-error]'); }
  function isActive(group, form) {
    const id = form.elements.namedItem('id')?.value;
    const allowed = (group.dataset.inksakeVariants || '').trim().split(/\s+/).filter(Boolean);
    return group.dataset.inksakeValidConfig === 'true' && !!id && allowed.includes(String(id));
  }
  function validate(form, opts) {
    opts = opts || {};
    let ok = true;
    for (const group of form.querySelectorAll(SEL)) {
      const fields = fieldsOf(group), err = errorOf(group);
      if (!fields.length) { ok = false; continue; }
      if (!isActive(group, form)) {
        // Inactive for the selected variant: do not require or submit anything.
        fields.forEach(f => { f.required = false; f.disabled = true; f.setCustomValidity(''); });
        hiddenOf(group).forEach(h => { h.disabled = true; });
        if (err) err.textContent = '';
        if (group.dataset.inksakeValidConfig !== 'true') ok = false;
        continue;
      }
      hiddenOf(group).forEach(h => { h.disabled = false; });
      let shown = '';
      for (const f of fields) {
        const line = lineOf(f);
        f.disabled = false; f.required = line === 1;
        if (opts.normalize) {
          const n = normalize(f.value).trim();
          if (n !== f.value) f.value = n;
        }
        const msg = check(line, f.value);
        f.setCustomValidity(msg);
        if (msg) {
          ok = false;
          // Stay quiet for an untouched empty required line until the buyer types or submits.
          if (!shown && (opts.report || f.value)) shown = msg;
        }
      }
      if (err) err.textContent = shown;
    }
    return ok;
  }
  // Block typing or pasting that would break the 20-characters-per-line limit or the character set.
  document.addEventListener('beforeinput', e => {
    const f = e.target;
    if (!(f instanceof HTMLInputElement) || !f.matches(FIELD)) return;
    if (!e.inputType || !e.inputType.startsWith('insert') || e.inputType === 'insertCompositionText') return;
    let inserted = '';
    if (e.inputType === 'insertLineBreak' || e.inputType === 'insertParagraph') { e.preventDefault(); return; }
    if (typeof e.data === 'string') inserted = e.data;
    else if (e.dataTransfer) inserted = e.dataTransfer.getData('text/plain') || '';
    const next = normalize(f.value.slice(0, f.selectionStart) + inserted + f.value.slice(f.selectionEnd));
    const msg = lineMessage(lineOf(f), next);
    if (msg) {
      e.preventDefault();
      const err = errorOf(f.closest(SEL));
      if (err) err.textContent = msg;
    }
  });
  document.addEventListener('input', e => {
    const f = e.target;
    if (f instanceof HTMLInputElement && f.matches(FIELD)) {
      const s = f.selectionStart, up = normalize(f.value);
      if (up !== f.value) { f.value = up; try { f.setSelectionRange(s, s); } catch (_) {} }
    }
    const form = e.target.closest && e.target.closest('form');
    if (form && form.querySelector(SEL)) validate(form, { report: true });
  });
  document.addEventListener('change', e => {
    const form = e.target.closest && e.target.closest('form');
    if (form && form.querySelector(SEL)) validate(form, { normalize: true, report: true });
  });
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector(SEL)) return;
    if (!validate(form, { normalize: true, report: true }) || !form.reportValidity()) {
      e.preventDefault(); e.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('formdata', e => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement) || !form.querySelector(SEL)) return;
    for (const group of form.querySelectorAll(SEL)) {
      for (const f of fieldsOf(group)) {
        if (f.disabled || !isActive(group, form)) continue;
        const value = normalize(f.value).trim();
        if (!check(lineOf(f), f.value) && value) e.formData.set(f.name, value);
        else e.formData.delete(f.name);
      }
    }
  });
  const init = () => document.querySelectorAll(SEL).forEach(g => { const f = g.closest('form'); if (f) validate(f); });
  init();
  // Re-check when the variant id changes (variant picker updates the hidden input).
  document.addEventListener('change', init);
  new MutationObserver(init).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['value'] });
})();
